module.exports = "/static/img/wc.17bc451.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resetPassword/wc.png
// module id = 185
// module chunks = 1